<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4 mb-6">
          <v-col cols="12">
            <div class="d-flex justify-space-between align-center">
              <h2>Milestone Slideshows</h2>
              <v-btn color="primary" depressed @click="openCreateSlideshowModal">New Slideshow</v-btn>
            </div>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row v-if="slideshowsLoading">
      <v-col class="text-center">
        <heart-loader />
      </v-col>
    </v-row>

    <v-row v-else-if="slideshows && slideshows.length">
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4">
          <v-data-table
            :headers="headers"
            :items="slideshows"
            :options="{ itemsPerPage: -1 }"
            sort-by="title"
            hide-default-footer
          >
            <template v-slot:item.active="{ item }">
              <v-checkbox
                v-model="item.active"
                @change="toggleActive(item)"
                dense
                hide-details
              ></v-checkbox>
            </template>
            <template v-slot:item.title="{ item }">
              <router-link :to="{ name: 'MilestoneSlideshowDetailRoute', params: { id: item.id } }">
                {{ item.title }}
              </router-link>
            </template>
            <template v-slot:item.slideCount="{ item }">
              {{ item.slides.length || 0 }} slides
            </template>
            <template v-slot:item.updatedAt="{ item }">
              {{ formatDate(item.updatedAt) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="primary" depressed @click="$router.push({ name: 'MilestoneSlideshowDetailRoute', params: { id: item.id } })">
                Edit
              </v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col class="text-center text--secondary">
        No slideshows found. Create one to get started.
      </v-col>
    </v-row>

    <v-dialog v-model="createSlideshowModal" max-width="400">
      <v-card>
        <v-card-title>Create Slideshow</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="slideshowTitle"
            label="Title"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="createSlideshowModal = false">Cancel</v-btn>
          <v-btn color="primary" depressed @click="createSlideshow">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import heartLoader from '@/components/heartLoader.vue'

export default {
  name: 'MilestoneSlideshowsPage',

  components: {
    heartLoader,
  },

  data() {
    return {
      createSlideshowModal: false,
      slideshowTitle: null,
      headers: [
        {
          text: 'Active',
          value: 'active',
          sortable: false,
          width: '80',
        },
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'Slides',
          value: 'slideCount',
          sortable: false,
        },
        {
          text: 'Updated',
          value: 'updatedAt',
          sortable: true,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '80',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      slideshows: 'milestone-slideshow/list',
      slides: 'milestone-slide/list'
    }),
    slideshowsLoading() {
      return this.$store.state['milestone-slideshow'].isFindPending
    },
    slideCounts() {
      const counts = {}
      this.slides.forEach(slide => {
        if (slide.slideshowId) {
          counts[slide.slideshowId] = (counts[slide.slideshowId] || 0) + 1
        }
      })
      return counts
    },
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleDateString()
    },
    openCreateSlideshowModal() {
      this.createSlideshowModal = true
      this.slideshowTitle = null
    },
    async createSlideshow() {
      const res = await this.$store.dispatch('milestone-slideshow/create', {
        title: this.slideshowTitle || 'Untitled Slideshow',
        active: false,
      })
      if (res) {
        this.$router.push({ name: 'MilestoneSlideshowDetailRoute', params: { id: res.id } })
      }
    },
    async toggleActive(item) {
      await this.$store.dispatch('milestone-slideshow/patch', [item.id, { active: item.active }])
    },
  },

  mounted() {
    this.$store.dispatch('milestone-slideshow/find', {
      query: {
        $limit: 500,
        $sort: { updatedAt: -1 },
      }
    })
    this.$store.dispatch('milestone-slide/find', {
      query: {
        $limit: 5000,
      }
    })
  },
}
</script>

<style lang="scss">

</style>
